// extracted by mini-css-extract-plugin
export const root = "subscribe-form-module--root--1CUwA";
export const button = "subscribe-form-module--button--1clRa";
export const response = "subscribe-form-module--response--3bwwl";
export const error = "subscribe-form-module--error--2mIxZ";
export const success = "subscribe-form-module--success--fnDnH";